export const findItemsByBatchId = (items = [], batchId) =>
  items.filter(item => item.batchId === batchId);
